/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway - PID Identity Verification
 * Backoffice integration for PID Identity Verification
 *
 * The version of the OpenAPI document: 1.2
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Nationality, ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase.
 * @export
 * @enum {string}
 */

export const CountryCodeV1x2 = {
    UNKNOWN: 'UNKNOWN',
    ABW: 'ABW',
    AFG: 'AFG',
    AGO: 'AGO',
    AIA: 'AIA',
    ALA: 'ALA',
    ALB: 'ALB',
    AND: 'AND',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ASM: 'ASM',
    ATA: 'ATA',
    ATF: 'ATF',
    ATG: 'ATG',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BES: 'BES',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHR: 'BHR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLM: 'BLM',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BMU: 'BMU',
    BOL: 'BOL',
    BRA: 'BRA',
    BRB: 'BRB',
    BRN: 'BRN',
    BTN: 'BTN',
    BVT: 'BVT',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CCK: 'CCK',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COK: 'COK',
    COL: 'COL',
    COM: 'COM',
    CPV: 'CPV',
    CRI: 'CRI',
    CUB: 'CUB',
    CUW: 'CUW',
    CXR: 'CXR',
    CYM: 'CYM',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DMA: 'DMA',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESH: 'ESH',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    FRO: 'FRO',
    FSM: 'FSM',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GGY: 'GGY',
    GHA: 'GHA',
    GIB: 'GIB',
    GIN: 'GIN',
    GLP: 'GLP',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRD: 'GRD',
    GRL: 'GRL',
    GTM: 'GTM',
    GUF: 'GUF',
    GUM: 'GUM',
    GUY: 'GUY',
    HKG: 'HKG',
    HMD: 'HMD',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IMN: 'IMN',
    IND: 'IND',
    IOT: 'IOT',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JEY: 'JEY',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KIR: 'KIR',
    KNA: 'KNA',
    KOR: 'KOR',
    KSV: 'KSV',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LCA: 'LCA',
    LIE: 'LIE',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAC: 'MAC',
    MAF: 'MAF',
    MAR: 'MAR',
    MCO: 'MCO',
    MDA: 'MDA',
    MDG: 'MDG',
    MDV: 'MDV',
    MEX: 'MEX',
    MHL: 'MHL',
    MKD: 'MKD',
    MLI: 'MLI',
    MLT: 'MLT',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MNP: 'MNP',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MSR: 'MSR',
    MTQ: 'MTQ',
    MUS: 'MUS',
    MWI: 'MWI',
    MYS: 'MYS',
    MYT: 'MYT',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NFK: 'NFK',
    NGA: 'NGA',
    NIC: 'NIC',
    NIU: 'NIU',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NRU: 'NRU',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PCN: 'PCN',
    PER: 'PER',
    PHL: 'PHL',
    PLW: 'PLW',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    PYF: 'PYF',
    QAT: 'QAT',
    REU: 'REU',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    SAU: 'SAU',
    SDN: 'SDN',
    SEN: 'SEN',
    SGP: 'SGP',
    SGS: 'SGS',
    SHN: 'SHN',
    SJM: 'SJM',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SMR: 'SMR',
    SOM: 'SOM',
    SPM: 'SPM',
    SRB: 'SRB',
    SSD: 'SSD',
    STP: 'STP',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SXM: 'SXM',
    SYC: 'SYC',
    SYR: 'SYR',
    TCA: 'TCA',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKL: 'TKL',
    TKM: 'TKM',
    TLS: 'TLS',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TUV: 'TUV',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    UMI: 'UMI',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VAT: 'VAT',
    VCT: 'VCT',
    VEN: 'VEN',
    VGB: 'VGB',
    VIR: 'VIR',
    VNM: 'VNM',
    VUT: 'VUT',
    WLF: 'WLF',
    WSM: 'WSM',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type CountryCodeV1x2 = typeof CountryCodeV1x2[keyof typeof CountryCodeV1x2];


/**
 * 
 * @export
 * @interface CreateVerificationRequestV1
 */
export interface CreateVerificationRequestV1 {
    /**
     * 
     * @type {boolean}
     * @memberof CreateVerificationRequestV1
     */
    'blockageRequired': boolean;
}
/**
 * 
 * @export
 * @interface CreateVerificationResponseV1
 */
export interface CreateVerificationResponseV1 {
    /**
     * UUID identifying the verification process
     * @type {string}
     * @memberof CreateVerificationResponseV1
     */
    'verificationUuid': string;
}
/**
 * ID card type
 * @export
 * @enum {string}
 */

export const IdCardTypeV11x2 = {
    ID: 'ID',
    OP: 'OP',
    P: 'P',
    CA: 'CA',
    DL: 'DL',
    IR: 'IR',
    BC: 'BC',
    VS: 'VS',
    PS: 'PS',
    IX: 'IX',
    IE: 'IE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type IdCardTypeV11x2 = typeof IdCardTypeV11x2[keyof typeof IdCardTypeV11x2];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x2
 */
export interface PageableResponseV1x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x2
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x2
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x2
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x2
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x2
 */
export interface PageableV1x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x2
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x2
     */
    'pageSize': number;
}
/**
 * Type of sample taken during identity verification process.
 * @export
 * @enum {string}
 */

export const SampleTypeV1 = {
    UNKNOWN: 'UNKNOWN',
    DOCUMENT_PICTURE: 'DocumentPicture',
    SELFIE_VIDEO: 'SelfieVideo'
} as const;

export type SampleTypeV1 = typeof SampleTypeV1[keyof typeof SampleTypeV1];


/**
 * 
 * @export
 * @interface SampleV1
 */
export interface SampleV1 {
    /**
     * 
     * @type {string}
     * @memberof SampleV1
     */
    'page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SampleV1
     */
    'rank'?: string;
    /**
     * 
     * @type {string}
     * @memberof SampleV1
     */
    'sampleId'?: string;
    /**
     * 
     * @type {SampleTypeV1}
     * @memberof SampleV1
     */
    'sampleType'?: SampleTypeV1;
}


/**
 * 
 * @export
 * @interface SearchVerificationsRequestExtendedV1
 */
export interface SearchVerificationsRequestExtendedV1 {
    /**
     * 
     * @type {string}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'completedAtFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'completedAtTo'?: string;
    /**
     * If true get only uncompleted verifications at the moment; false get all items
     * @type {boolean}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'onlyUncompleted'?: boolean;
    /**
     * 
     * @type {PageableV1x2}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'pageable': PageableV1x2;
    /**
     * 
     * @type {SortV1}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'sort'?: SortV1;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'verificationState'?: VerificationStateTypeV1;
    /**
     * Search by PID UUID
     * @type {string}
     * @memberof SearchVerificationsRequestExtendedV1
     */
    'pidUuid'?: string;
}


/**
 * 
 * @export
 * @interface SearchVerificationsRequestExtendedV1AllOf
 */
export interface SearchVerificationsRequestExtendedV1AllOf {
    /**
     * Search by PID UUID
     * @type {string}
     * @memberof SearchVerificationsRequestExtendedV1AllOf
     */
    'pidUuid'?: string;
}
/**
 * 
 * @export
 * @interface SearchVerificationsRequestV1
 */
export interface SearchVerificationsRequestV1 {
    /**
     * 
     * @type {string}
     * @memberof SearchVerificationsRequestV1
     */
    'completedAtFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchVerificationsRequestV1
     */
    'completedAtTo'?: string;
    /**
     * If true get only uncompleted verifications at the moment; false get all items
     * @type {boolean}
     * @memberof SearchVerificationsRequestV1
     */
    'onlyUncompleted'?: boolean;
    /**
     * 
     * @type {PageableV1x2}
     * @memberof SearchVerificationsRequestV1
     */
    'pageable': PageableV1x2;
    /**
     * 
     * @type {SortV1}
     * @memberof SearchVerificationsRequestV1
     */
    'sort'?: SortV1;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof SearchVerificationsRequestV1
     */
    'verificationState'?: VerificationStateTypeV1;
}


/**
 * Identity verifications matching given criteria
 * @export
 * @interface SearchVerificationsResponseExtendedV1
 */
export interface SearchVerificationsResponseExtendedV1 {
    /**
     * 
     * @type {PageableResponseV1x2}
     * @memberof SearchVerificationsResponseExtendedV1
     */
    'pageable': PageableResponseV1x2;
    /**
     * 
     * @type {Array<VerificationSearchItemExtendedV1>}
     * @memberof SearchVerificationsResponseExtendedV1
     */
    'results': Array<VerificationSearchItemExtendedV1>;
}
/**
 * Identity verifications matching given criteria
 * @export
 * @interface SearchVerificationsResponseV1
 */
export interface SearchVerificationsResponseV1 {
    /**
     * 
     * @type {PageableResponseV1x2}
     * @memberof SearchVerificationsResponseV1
     */
    'pageable': PageableResponseV1x2;
    /**
     * 
     * @type {Array<VerificationSearchItemV1>}
     * @memberof SearchVerificationsResponseV1
     */
    'results': Array<VerificationSearchItemV1>;
}
/**
 * Supported sortable fields for search.
 * @export
 * @enum {string}
 */

export const SortNameV1 = {
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt'
} as const;

export type SortNameV1 = typeof SortNameV1[keyof typeof SortNameV1];


/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x2 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x2 = typeof SortOrderTypeV1x2[keyof typeof SortOrderTypeV1x2];


/**
 * 
 * @export
 * @interface SortV1
 */
export interface SortV1 {
    /**
     * 
     * @type {SortNameV1}
     * @memberof SortV1
     */
    'name'?: SortNameV1;
    /**
     * 
     * @type {SortOrderTypeV1x2}
     * @memberof SortV1
     */
    'order'?: SortOrderTypeV1x2;
}


/**
 * 
 * @export
 * @interface VerificationActionsV1
 */
export interface VerificationActionsV1 {
    /**
     * 
     * @type {boolean}
     * @memberof VerificationActionsV1
     */
    'manualIdentityVerificationAllowed': boolean;
}
/**
 * 
 * @export
 * @interface VerificationDetailV1
 */
export interface VerificationDetailV1 {
    /**
     * 
     * @type {VerificationDetailV1Blockage}
     * @memberof VerificationDetailV1
     */
    'blockage'?: VerificationDetailV1Blockage;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'deviceBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'deviceIndustrialDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {CountryCodeV1x2}
     * @memberof VerificationDetailV1
     */
    'idCardCountry'?: CountryCodeV1x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'idCardNumber'?: string;
    /**
     * 
     * @type {IdCardTypeV11x2}
     * @memberof VerificationDetailV1
     */
    'idCardType'?: IdCardTypeV11x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'ocrInvestigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'ocrProfile'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {Array<SampleV1>}
     * @memberof VerificationDetailV1
     */
    'samples': Array<SampleV1>;
    /**
     * 
     * @type {Array<VerificationTransitionV1>}
     * @memberof VerificationDetailV1
     */
    'transitions': Array<VerificationTransitionV1>;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof VerificationDetailV1
     */
    'verificationState': VerificationStateTypeV1;
    /**
     * UUID identifying the verification process
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'verificationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDetailV1
     */
    'updatedAt': string;
    /**
     * 
     * @type {VerificationActionsV1}
     * @memberof VerificationDetailV1
     */
    'actions': VerificationActionsV1;
}


/**
 * 
 * @export
 * @interface VerificationDetailV1Blockage
 */
export interface VerificationDetailV1Blockage {
    /**
     * 
     * @type {VerificationReasonTypeV1}
     * @memberof VerificationDetailV1Blockage
     */
    'blockageReason'?: VerificationReasonTypeV1;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationDetailV1Blockage
     */
    'blockageRequired'?: boolean;
}


/**
 * Reason for creating identity verification
 * @export
 * @enum {string}
 */

export const VerificationReasonTypeV1 = {
    AD_HOC_BOA: 'AD_HOC_BOA',
    BANKID_PHONE_DIFFERS: 'BANKID_PHONE_DIFFERS',
    EMAIL_CHANGE: 'EMAIL_CHANGE',
    PHONE_CHANGE: 'PHONE_CHANGE'
} as const;

export type VerificationReasonTypeV1 = typeof VerificationReasonTypeV1[keyof typeof VerificationReasonTypeV1];


/**
 * 
 * @export
 * @interface VerificationSearchItemExtendedV1
 */
export interface VerificationSearchItemExtendedV1 {
    /**
     * 
     * @type {boolean}
     * @memberof VerificationSearchItemExtendedV1
     */
    'blockage': boolean;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'deviceBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'deviceIndustrialDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {CountryCodeV1x2}
     * @memberof VerificationSearchItemExtendedV1
     */
    'idCardCountry'?: CountryCodeV1x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'idCardNumber'?: string;
    /**
     * 
     * @type {IdCardTypeV11x2}
     * @memberof VerificationSearchItemExtendedV1
     */
    'idCardType'?: IdCardTypeV11x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof VerificationSearchItemExtendedV1
     */
    'verificationState': VerificationStateTypeV1;
    /**
     * UUID identifying the verification process
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'verificationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1
     */
    'fullName'?: string;
}


/**
 * 
 * @export
 * @interface VerificationSearchItemExtendedV1AllOf
 */
export interface VerificationSearchItemExtendedV1AllOf {
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemExtendedV1AllOf
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @interface VerificationSearchItemV1
 */
export interface VerificationSearchItemV1 {
    /**
     * 
     * @type {boolean}
     * @memberof VerificationSearchItemV1
     */
    'blockage': boolean;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'deviceBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'deviceIndustrialDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {CountryCodeV1x2}
     * @memberof VerificationSearchItemV1
     */
    'idCardCountry'?: CountryCodeV1x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'idCardNumber'?: string;
    /**
     * 
     * @type {IdCardTypeV11x2}
     * @memberof VerificationSearchItemV1
     */
    'idCardType'?: IdCardTypeV11x2;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof VerificationSearchItemV1
     */
    'verificationState': VerificationStateTypeV1;
    /**
     * UUID identifying the verification process
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'verificationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationSearchItemV1
     */
    'updatedAt': string;
}


/**
 * Status of identity verification process.
 * @export
 * @enum {string}
 */

export const VerificationStateTypeV1 = {
    UNKNOWN: 'UNKNOWN',
    VERIFICATION_CREATED: 'VERIFICATION_CREATED',
    SIGN_OPERATION_PREPARED: 'SIGN_OPERATION_PREPARED',
    ID_SCANNING: 'ID_SCANNING',
    ID_SCANNED: 'ID_SCANNED',
    VERIFICATION_SUCCESSFUL: 'VERIFICATION_SUCCESSFUL',
    IDENTITY_VERIFICATION_FAILED: 'IDENTITY_VERIFICATION_FAILED',
    MANUAL_IDENTITY_VERIFICATION_REQUIRED: 'MANUAL_IDENTITY_VERIFICATION_REQUIRED',
    VERIFICATION_FAILED: 'VERIFICATION_FAILED'
} as const;

export type VerificationStateTypeV1 = typeof VerificationStateTypeV1[keyof typeof VerificationStateTypeV1];


/**
 * 
 * @export
 * @interface VerificationTransitionV1
 */
export interface VerificationTransitionV1 {
    /**
     * 
     * @type {string}
     * @memberof VerificationTransitionV1
     */
    'documentSignOperationUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationTransitionV1
     */
    'documentUploadSessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationTransitionV1
     */
    'sourceTask': string;
    /**
     * 
     * @type {VerificationStateTypeV1}
     * @memberof VerificationTransitionV1
     */
    'verificationState': VerificationStateTypeV1;
    /**
     * 
     * @type {string}
     * @memberof VerificationTransitionV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationTransitionV1
     */
    'updatedAt': string;
}




/**
 * IdentityVerificationApi - axios parameter creator
 * @export
 */
export const IdentityVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Approve identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveIdentityV1: async (xCorrelationId: string, pidUuid: string, verificationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('approveIdentityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('approveIdentityV1', 'pidUuid', pidUuid)
            // verify required parameter 'verificationUuid' is not null or undefined
            assertParamExists('approveIdentityV1', 'verificationUuid', verificationUuid)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/pid/{pidUuid}/identity-verifications/{verificationUuid}/approve-identity`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)))
                .replace(`{${"verificationUuid"}}`, encodeURIComponent(String(verificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {CreateVerificationRequestV1} createVerificationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationV1: async (xCorrelationId: string, pidUuid: string, createVerificationRequestV1: CreateVerificationRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('createVerificationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('createVerificationV1', 'pidUuid', pidUuid)
            // verify required parameter 'createVerificationRequestV1' is not null or undefined
            assertParamExists('createVerificationV1', 'createVerificationRequestV1', createVerificationRequestV1)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/pid/{pidUuid}/identity-verifications/create-verification`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVerificationRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve details of a specific identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerificationV1: async (xCorrelationId: string, pidUuid: string, verificationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getIdentityVerificationV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getIdentityVerificationV1', 'pidUuid', pidUuid)
            // verify required parameter 'verificationUuid' is not null or undefined
            assertParamExists('getIdentityVerificationV1', 'verificationUuid', verificationUuid)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/pid/{pidUuid}/identity-verifications/{verificationUuid}`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)))
                .replace(`{${"verificationUuid"}}`, encodeURIComponent(String(verificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rejection identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectIdentityV1: async (xCorrelationId: string, pidUuid: string, verificationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('rejectIdentityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('rejectIdentityV1', 'pidUuid', pidUuid)
            // verify required parameter 'verificationUuid' is not null or undefined
            assertParamExists('rejectIdentityV1', 'verificationUuid', verificationUuid)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/pid/{pidUuid}/identity-verifications/{verificationUuid}/reject-identity`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)))
                .replace(`{${"verificationUuid"}}`, encodeURIComponent(String(verificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search identity verifications based on given criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchVerificationsRequestExtendedV1} searchVerificationsRequestExtendedV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllIdentityVerificationsV1: async (xCorrelationId: string, searchVerificationsRequestExtendedV1: SearchVerificationsRequestExtendedV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchAllIdentityVerificationsV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchVerificationsRequestExtendedV1' is not null or undefined
            assertParamExists('searchAllIdentityVerificationsV1', 'searchVerificationsRequestExtendedV1', searchVerificationsRequestExtendedV1)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/identity-verifications/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchVerificationsRequestExtendedV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search identity verifications of given client based on given criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {SearchVerificationsRequestV1} searchVerificationsRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchIdentityVerificationsOfClientV1: async (xCorrelationId: string, pidUuid: string, searchVerificationsRequestV1: SearchVerificationsRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchIdentityVerificationsOfClientV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('searchIdentityVerificationsOfClientV1', 'pidUuid', pidUuid)
            // verify required parameter 'searchVerificationsRequestV1' is not null or undefined
            assertParamExists('searchIdentityVerificationsOfClientV1', 'searchVerificationsRequestV1', searchVerificationsRequestV1)
            const localVarPath = `/pid-backofficegateway-pididentityverification/v1/pid/{pidUuid}/identity-verifications/search`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchVerificationsRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentityVerificationApi - functional programming interface
 * @export
 */
export const IdentityVerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentityVerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Approve identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveIdentityV1(xCorrelationId: string, pidUuid: string, verificationUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveIdentityV1(xCorrelationId, pidUuid, verificationUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {CreateVerificationRequestV1} createVerificationRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVerificationV1(xCorrelationId: string, pidUuid: string, createVerificationRequestV1: CreateVerificationRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVerificationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVerificationV1(xCorrelationId, pidUuid, createVerificationRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve details of a specific identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityVerificationV1(xCorrelationId: string, pidUuid: string, verificationUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationDetailV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityVerificationV1(xCorrelationId, pidUuid, verificationUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Rejection identity verification.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {string} verificationUuid UUID identifying the verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectIdentityV1(xCorrelationId: string, pidUuid: string, verificationUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectIdentityV1(xCorrelationId, pidUuid, verificationUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search identity verifications based on given criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchVerificationsRequestExtendedV1} searchVerificationsRequestExtendedV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAllIdentityVerificationsV1(xCorrelationId: string, searchVerificationsRequestExtendedV1: SearchVerificationsRequestExtendedV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchVerificationsResponseExtendedV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAllIdentityVerificationsV1(xCorrelationId, searchVerificationsRequestExtendedV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search identity verifications of given client based on given criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {SearchVerificationsRequestV1} searchVerificationsRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchIdentityVerificationsOfClientV1(xCorrelationId: string, pidUuid: string, searchVerificationsRequestV1: SearchVerificationsRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchVerificationsResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchIdentityVerificationsOfClientV1(xCorrelationId, pidUuid, searchVerificationsRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IdentityVerificationApi - factory interface
 * @export
 */
export const IdentityVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentityVerificationApiFp(configuration)
    return {
        /**
         * Approve identity verification.
         * @param {IdentityVerificationApiApproveIdentityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveIdentityV1(requestParameters: IdentityVerificationApiApproveIdentityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.approveIdentityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Create identity verification.
         * @param {IdentityVerificationApiCreateVerificationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationV1(requestParameters: IdentityVerificationApiCreateVerificationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CreateVerificationResponseV1> {
            return localVarFp.createVerificationV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.createVerificationRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve details of a specific identity verification.
         * @param {IdentityVerificationApiGetIdentityVerificationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerificationV1(requestParameters: IdentityVerificationApiGetIdentityVerificationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<VerificationDetailV1> {
            return localVarFp.getIdentityVerificationV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Rejection identity verification.
         * @param {IdentityVerificationApiRejectIdentityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectIdentityV1(requestParameters: IdentityVerificationApiRejectIdentityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.rejectIdentityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search identity verifications based on given criteria.
         * @param {IdentityVerificationApiSearchAllIdentityVerificationsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllIdentityVerificationsV1(requestParameters: IdentityVerificationApiSearchAllIdentityVerificationsV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchVerificationsResponseExtendedV1> {
            return localVarFp.searchAllIdentityVerificationsV1(requestParameters.xCorrelationId, requestParameters.searchVerificationsRequestExtendedV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search identity verifications of given client based on given criteria.
         * @param {IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchIdentityVerificationsOfClientV1(requestParameters: IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchVerificationsResponseV1> {
            return localVarFp.searchIdentityVerificationsOfClientV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.searchVerificationsRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveIdentityV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiApproveIdentityV1Request
 */
export type IdentityVerificationApiApproveIdentityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiApproveIdentityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationApiApproveIdentityV1
     */
    readonly pidUuid: string

    /**
     * UUID identifying the verification
     * @type {string}
     * @memberof IdentityVerificationApiApproveIdentityV1
     */
    readonly verificationUuid: string
}

/**
 * Request parameters for createVerificationV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiCreateVerificationV1Request
 */
export type IdentityVerificationApiCreateVerificationV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiCreateVerificationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationApiCreateVerificationV1
     */
    readonly pidUuid: string

    /**
     * 
     * @type {CreateVerificationRequestV1}
     * @memberof IdentityVerificationApiCreateVerificationV1
     */
    readonly createVerificationRequestV1: CreateVerificationRequestV1
}

/**
 * Request parameters for getIdentityVerificationV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiGetIdentityVerificationV1Request
 */
export type IdentityVerificationApiGetIdentityVerificationV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiGetIdentityVerificationV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationApiGetIdentityVerificationV1
     */
    readonly pidUuid: string

    /**
     * UUID identifying the verification
     * @type {string}
     * @memberof IdentityVerificationApiGetIdentityVerificationV1
     */
    readonly verificationUuid: string
}

/**
 * Request parameters for rejectIdentityV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiRejectIdentityV1Request
 */
export type IdentityVerificationApiRejectIdentityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiRejectIdentityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationApiRejectIdentityV1
     */
    readonly pidUuid: string

    /**
     * UUID identifying the verification
     * @type {string}
     * @memberof IdentityVerificationApiRejectIdentityV1
     */
    readonly verificationUuid: string
}

/**
 * Request parameters for searchAllIdentityVerificationsV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiSearchAllIdentityVerificationsV1Request
 */
export type IdentityVerificationApiSearchAllIdentityVerificationsV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiSearchAllIdentityVerificationsV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchVerificationsRequestExtendedV1}
     * @memberof IdentityVerificationApiSearchAllIdentityVerificationsV1
     */
    readonly searchVerificationsRequestExtendedV1: SearchVerificationsRequestExtendedV1
}

/**
 * Request parameters for searchIdentityVerificationsOfClientV1 operation in IdentityVerificationApi.
 * @export
 * @type IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request
 */
export type IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof IdentityVerificationApiSearchIdentityVerificationsOfClientV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationApiSearchIdentityVerificationsOfClientV1
     */
    readonly pidUuid: string

    /**
     * 
     * @type {SearchVerificationsRequestV1}
     * @memberof IdentityVerificationApiSearchIdentityVerificationsOfClientV1
     */
    readonly searchVerificationsRequestV1: SearchVerificationsRequestV1
}

/**
 * IdentityVerificationApi - object-oriented interface
 * @export
 * @class IdentityVerificationApi
 * @extends {BaseAPI}
 */
export class IdentityVerificationApi extends BaseAPI {
    /**
     * Approve identity verification.
     * @param {IdentityVerificationApiApproveIdentityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public approveIdentityV1(requestParameters: IdentityVerificationApiApproveIdentityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).approveIdentityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create identity verification.
     * @param {IdentityVerificationApiCreateVerificationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public createVerificationV1(requestParameters: IdentityVerificationApiCreateVerificationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).createVerificationV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.createVerificationRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve details of a specific identity verification.
     * @param {IdentityVerificationApiGetIdentityVerificationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public getIdentityVerificationV1(requestParameters: IdentityVerificationApiGetIdentityVerificationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).getIdentityVerificationV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rejection identity verification.
     * @param {IdentityVerificationApiRejectIdentityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public rejectIdentityV1(requestParameters: IdentityVerificationApiRejectIdentityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).rejectIdentityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verificationUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search identity verifications based on given criteria.
     * @param {IdentityVerificationApiSearchAllIdentityVerificationsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public searchAllIdentityVerificationsV1(requestParameters: IdentityVerificationApiSearchAllIdentityVerificationsV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).searchAllIdentityVerificationsV1(requestParameters.xCorrelationId, requestParameters.searchVerificationsRequestExtendedV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search identity verifications of given client based on given criteria.
     * @param {IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityVerificationApi
     */
    public searchIdentityVerificationsOfClientV1(requestParameters: IdentityVerificationApiSearchIdentityVerificationsOfClientV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return IdentityVerificationApiFp(this.configuration).searchIdentityVerificationsOfClientV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.searchVerificationsRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


